/* The Sujatra product page's behaviour.
 *
 * Lifted out of the section on 2026-10-02, because publishing a theme file here
 * means uploading the whole file by hand and the section had grown to 35KB,
 * over half of it this script. It carries no Liquid, which made the move safe.
 *
 * THE ADD PATH IS NOT IN HERE AND MUST NOT BE. A Buy now button, a Magic
 * Checkout hook and a replacement for theme.liquid's add-to-cart handler all
 * went in together and came out together when adding stopped working. Nothing
 * in this file adds, unbinds or intercepts an add; it reads state, presses
 * controls that already exist, and writes text and class names.
 */

  /* DID THIS PAGE JUST COME BACK FROM AN ADD?
     Read at parse time, once, and shared by everything below. theme.liquid sets
     `openDrawerAfterReload` on a successful add-on add and reads it back in its
     own DOMContentLoaded handler to open the cart drawer; that handler is
     registered in the head, so the only way to see the flag -- and to stop the
     drawer -- is to get there while the document is still parsing. */
  var sjpJustAdded = false;
  try {
    if (sessionStorage.getItem('openDrawerAfterReload') === 'true') {
      sessionStorage.removeItem('openDrawerAfterReload');
      sjpJustAdded = true;
    }
  } catch (e) {}

  /* WHICH BUTTON ON THIS PAGE ACTUALLY ADDS TO CART. */
  function sjpRealCta() {
    var ctas = document.querySelector('.sjp__ctas');
    if (!ctas) return null;
    var all = ctas.querySelectorAll(
      '.add_to_cartt_bundle, .fake-atc-btn__custom, .product-form__submit'
    );
    return Array.prototype.filter.call(all, function (b) {
      return b.offsetParent !== null;
    })[0] || null;
  }

  /* A decoy adds nothing. Both of these only print "choose your size first". */
  function sjpIsDecoy(b) {
    return !!b && (b.classList.contains('fake-atc-btn__custom') ||
                   b.classList.contains('add_to_cartt_bundle1'));
  }

  (function () {
    'use strict';
    var bar = document.querySelector('[data-sjp-stick]');
    var ctas = document.querySelector('.sjp__ctas');
    if (!bar || !ctas || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { rootMargin: '0px 0px -40px 0px' }).observe(ctas);

    /* The bar presses the page's real Add to cart rather than submitting the
       product form itself. On a product with a bundle the form posts the parent
       variant alone, so a form submit here would quietly drop the pant and the
       dupatta someone had just ticked. */
    var btn = bar.querySelector('.sjp-stick__btn');
    if (btn) {
      btn.addEventListener('click', function (e) {
        /* FIRST, UNCONDITIONALLY. Returning before this let the browser run the
           button's own default action, and while it was a form submit that
           posted the parent variant without the ticked add-ons. */
        e.preventDefault();

        var real = sjpRealCta();
        if (!real) {
          var p = document.querySelector('.sjp__variants');
          if (p) p.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        real.click();

        if (sjpIsDecoy(real)) {
          var picker = document.querySelector('.sjp__variants');
          if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    var barPrice = bar.querySelector('.sjp-stick__meta b');

    function syncBarPrice() {
      /* Re-queried rather than captured: the span is written by the bundle
         snippet, which renders on more pages since 27 Oct. */
      var runningTotal = document.querySelector('.bundle-total-price');
      if (!barPrice || !runningTotal) return;
      /* ⚠ "·" BELONGS IN THIS CLASS. The span owns its separator -- " · " since
         26 Oct, " - " on a theme copy not yet updated -- so strip whatever
         leads rather than assume which. Without the middle dot the bar read
         "MRP · ₹4,700/-". */
      var t = runningTotal.textContent.replace(/\s+/g, ' ').trim().replace(/^[-–—·\s]+/, '');
      if (t) barPrice.textContent = 'MRP ' + t + '/-';
    }

    /* ⚠ WATCH THE TOTAL, DO NOT GUESS WHEN IT MOVES. The `change` listener
       below fires before Dawn has re-rendered and before the calculator has
       written the new figure, so the bar copied the PREVIOUS option's price --
       visible on 27 Oct as a sticky bar one step behind the headline. */
    (function () {
      var el = document.querySelector('.bundle-total-price');
      if (!el) return;
      new MutationObserver(syncBarPrice)
        .observe(el, { childList: true, characterData: true, subtree: true });
    })();

    /* The chosen size, once there is one.
       `picked` exists because the theme pre-checks the first radio: reading
       `:checked` on load would print "Size XS" at someone who has chosen
       nothing, on a page whose own Add to cart refuses to fire until they do. */
    var sizeEl = bar.querySelector('[data-sjp-size]');
    var picked = false;

    function syncSize() {
      if (!sizeEl || !picked) return;
      var r = document.querySelector('.sjp__variants input[type="radio"]:checked');
      if (!r || !r.value) return;
      sizeEl.textContent = 'Size ' + r.value;
      sizeEl.hidden = false;
    }

    document.addEventListener('change', function (e) {
      syncBarPrice();
      if (e.target && e.target.closest && e.target.closest('.sjp__variants')) {
        picked = true;
        syncSize();
      }
    }, true);
    document.addEventListener('click', function () { window.setTimeout(syncBarPrice, 250); }, true);
    syncBarPrice();
  })();

  /* The bundle block's real Add to cart, moved to where the mockup puts it. */
  (function () {
    'use strict';
    var ctas = document.querySelector('.sjp__ctas');
    var real = document.querySelector('.bundle-products a.add_to_cartt_bundle.triggerr_productt');
    if (ctas && real) ctas.appendChild(real);
  })();

  /* Add pant / Add dupatta: the whole row is the control. */
  (function () {
    'use strict';
    var rows = document.querySelector('.bundle-products');
    if (!rows) return;

    rows.addEventListener('click', function (e) {
      var row = e.target.closest('.bundle-product');
      if (!row) return;
      if (e.target.closest('select, a, option, label')) return;

      var box = row.querySelector('.bundle-product-checkbox');
      if (!box || e.target === box) return;

      box.checked = !box.checked;
      box.dispatchEvent(new Event('change', { bubbles: true }));
    });

    var inbox = document.querySelector('[data-inbox]');
    if (!inbox) return;

    var line = inbox.querySelector('[data-inbox-line]');
    var base = (inbox.getAttribute('data-inbox-base') || '').split(',');
    for (var b = base.length - 1; b >= 0; b--) {
      base[b] = base[b].replace(/^\s+|\s+$/g, '');
      if (!base[b]) base.splice(b, 1);
    }

    function sentence(pieces) {
      if (!pieces.length) return '';
      var lead = pieces[0];
      var rest = pieces.slice(1);
      if (!rest.length) return lead + ' only';
      if (rest.length === 1) return lead + ' with ' + rest[0];
      return lead + ' with ' + rest.slice(0, -1).join(', ') + ' and ' + rest[rest.length - 1];
    }

    /* ⚠ THE PRICED BUTTON IS GATED ON A SIZE. THIS LINE IS NOT, ON PURPOSE.
       bundle-product.liquid shows the real CTA — the one reading
       "ADD TO CART · ₹2,498" — only once a size is picked, because that button
       IS the submit and a size-less add must not happen. Correct, and left
       alone.

       The total, though, never depends on size: every size of a kurta is the
       same price. So the gate hid the number at exactly the moment a shopper
       decides whether to add the pant. Bed, 26 Oct 2026, looking at that state:
       "the toral amount product plus child is not showing".

       READ, NEVER RECOMPUTED. The figure comes from the button's own span, so
       prices are summed in one place and the two lines cannot drift apart. */
    var totalEl = document.querySelector('.bundle-total-price');

    function runningTotal() {
      if (!totalEl) return '';
      /* The span carries its own separator — " · " now, " - " on a theme copy
         not yet updated — so strip whatever leads rather than assume which. */
      return (totalEl.textContent || '')
        .replace(/\s+/g, ' ')
        .replace(/^[-–—·\s]+/, '')
        .trim();
    }

    function syncInbox() {
      if (!line) return;
      var pieces = base.slice();
      var boxes = rows.querySelectorAll('.bundle-product-checkbox');
      for (var i = 0; i < boxes.length; i++) {
        if (!boxes[i].checked) continue;
        var rec = inbox.querySelector('[data-inbox-for="' + boxes[i].value + '"]');
        var name = rec ? rec.getAttribute('data-inbox-name') : '';
        if (name && pieces.indexOf(name) === -1) pieces.push(name);
      }
      var txt = sentence(pieces);
      var total = runningTotal();
      line.textContent = total ? txt + ' · ' + total : txt;
    }

    rows.addEventListener('change', syncInbox);

    /* bundle-product.liquid updates the total on its OWN 'change' listener and
       nothing orders the two, so reading it inside this one is a race. Watching
       the span settles it whichever fires first, and also catches the first
       paint, where the total is written before this block binds. */
    if (totalEl && window.MutationObserver) {
      new MutationObserver(syncInbox).observe(
        totalEl, { childList: true, characterData: true, subtree: true });
    }

    syncInbox();
  })();

  /* PUT THE CHOSEN SIZE BACK AFTER AN ADD, AND KEEP THE BUTTON OPEN.

     The size is remembered here rather than read from `?variant=`: the first
     attempt keyed on that URL parameter and it does not survive the reload, so
     the restore never ran at all.

     BY CLICKING THE LABEL, NOT BY SETTING `.checked`. The chosen size has to
     reach the form's hidden `input[name="id"]`, and only the real event chain
     does that. Set `.checked` quietly and the page would look right while
     adding the wrong size, which is worse than the bug being fixed.

     Only after an add. Restoring a size on an ordinary visit would walk past
     the deliberate "choose your size first" gate for every customer. */
  (function () {
    'use strict';

    var picker = document.querySelector('.sjp__variants');
    if (!picker) return;

    var KEY = 'sjt_size_' + (window.location.pathname || '');

    function radios() {
      return picker.querySelectorAll('input[type="radio"]');
    }

    picker.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio' || !t.value) return;
      try { sessionStorage.setItem(KEY, t.value); } catch (err) {}
    });

    if (!sjpJustAdded) return;

    /* THE TWO GATES, AND WHY TELLING THEM ONCE IS NOT ENOUGH.

       buy-buttons.liquid guards the product form with `-custom2` class names;
       bundle-product.liquid guards the add-on anchor with the bare ones. Both
       hide their real button on load and only reveal it on a variant `change`.

       Restoring the size fires that change -- and then product-info fetches the
       section for the chosen variant and REPLACES this part of the DOM with
       freshly rendered server HTML, in which both gates are back to their
       default hidden state. So the button appeared and vanished again.

       Hence an observer. It re-opens the gates every time that subtree is
       rewritten, for a few seconds after the add, and then stops. It only
       touches a button that is currently hidden, so it cannot loop. */
    var GATES = [
      { real: '.btn__custm_fake', fake: '.fake-atc-btn__custom',
        hide: 'force-hide-custom2', show: 'force-show-custom2', err: '.size-error-msg44' },
      { real: 'a.add_to_cartt_bundle.triggerr_productt', fake: 'a.fake-add-to-cart',
        hide: 'force-hide', show: 'force-show', err: '.size-error-msg' }
    ];

    function openGates() {
      for (var i = 0; i < GATES.length; i++) {
        var g = GATES[i];
        var real = document.querySelector(g.real);
        var fake = document.querySelector(g.fake);
        var err = document.querySelector(g.err);

        if (real && real.classList.contains(g.hide)) {
          real.classList.remove(g.hide);
          real.classList.add(g.show);
        }
        if (fake && fake.classList.contains(g.show)) {
          fake.classList.remove(g.show);
          fake.classList.add(g.hide);
        }
        if (err && err.style.display !== 'none') {
          err.style.setProperty('display', 'none', 'important');
        }
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      var want;
      try { want = sessionStorage.getItem(KEY); } catch (err) { return; }
      if (!want) return;

      var all = radios();
      for (var i = 0; i < all.length; i++) {
        if (all[i].value !== want) continue;

        if (all[i].checked) {
          all[i].dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          var label = picker.querySelector('label[for="' + all[i].id + '"]');
          if (label) label.click(); else all[i].click();
        }
        break;
      }

      openGates();

      var host = document.querySelector('.sjp-info') || document.body;
      if (!window.MutationObserver || !host) return;

      var until = Date.now() + 4000;
      var obs = new MutationObserver(function () {
        if (Date.now() > until) { obs.disconnect(); return; }
        openGates();
      });
      obs.observe(host, { childList: true, subtree: true });
      window.setTimeout(function () { obs.disconnect(); }, 4200);
    });
  })();

  /* "ADDED TO CART", ON THE BUTTON THAT WAS PRESSED. */
  (function () {
    'use strict';

    var RESTORE_AFTER = 2200;

    /* WHICH NODE CARRIES THE LABEL, WHICH IS NOT THE SAME QUESTION ON EVERY
       BUTTON.

       Dawn's submit is `<button><span>Add to cart</span><div class="loading__spinner">
       ...</div></button>` -- the span IS the label, and the button must not be
       touched because product-form.js holds references to both children from
       its constructor: write over the button and the spinner it reaches for on
       every submit is gone, and the next add throws.

       The bundle's anchor is the other shape: its label is a bare text node
       with a span beside it. Writing into that span left the original text in
       place and the button read "ADD TO CART ✓ ADDED TO CART".

       So: use the span only when the element has no text of its own. */
    function labelNode(el) {
      var span = el.querySelector('span');
      if (!span) return el;
      var own = '';
      for (var n = el.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3) own += n.nodeValue;
      }
      return own.replace(/\s+/g, '') ? el : span;
    }

    function flash(el) {
      if (!el || el.dataset.sjpFlashing === '1') return;
      var label = labelNode(el);
      var was = label.innerHTML;
      el.dataset.sjpFlashing = '1';
      label.textContent = '✓ ADDED TO CART';
      window.setTimeout(function () {
        label.innerHTML = was;
        delete el.dataset.sjpFlashing;
      }, RESTORE_AFTER);
    }

    function confirmAdd() {
      flash(sjpRealCta());
      flash(document.querySelector('.sjp-stick__btn'));
    }

    document.addEventListener('DOMContentLoaded', function () {
      if (sjpJustAdded) confirmAdd();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, confirmAdd);
      }
    });
  })();

/* ── THE FILM IN THE GALLERY PLAYS ITSELF ───────────────────────────────────
 *
 * The garment's own reel sits at slide 2 of its photographs (Bed: "film to be
 * on 2nd slide and autoplay when user reaches the slide - not 1st" — slide 1
 * would become the product's featured_media and turn every collection tile
 * into the film's first frame). It plays muted when you reach it and pauses
 * when you leave.
 *
 * ⚠ WE OWN THE <video>, WE DO NOT DRIVE DAWN'S. Dawn hides the inline player
 * below 750px — '.product__media-list .deferred-media { display: none }' — on
 * purpose: its design is that a phone opens video in a modal. Everything
 * inside that element is therefore unreachable on a phone. Its poster button
 * cannot be pressed, a button added inside it is invisible, and a video played
 * inside it plays where nobody can see it, reporting paused:false all the
 * while. That one fact produced five different-looking bugs over five rounds.
 *
 * So the <video> is lifted out of Dawn's <template> and placed directly in
 * .product-media-container, which is the box the slide actually shows. Dawn's
 * own player, poster and modal are untouched and still work; this just does
 * not rely on them.
 *
 * ⚠ GEOMETRY ON EVERY FRAME, NOT AN IntersectionObserver — an observer reports
 * only what changed, only at a threshold, only about the node you hand it, and
 * was wrong three times for three different reasons before this.
 */
(function () {
  /* ⚠ NOT AN EARLY RETURN. Reduced motion means do not autoplay; it must not
     mean there is no way to play. */
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  (function () {
    if (document.getElementById('sjp-film-css')) return;
    var s = document.createElement('style');
    s.id = 'sjp-film-css';
    s.textContent =
      '.sjp-film-video{position:absolute;top:0;left:0;width:100%;height:100%;' +
      'object-fit:cover;display:block;z-index:1}' +
      '.sjp-film-btn{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);' +
      'width:66px;height:66px;padding:0;border:0;border-radius:50%;cursor:pointer;z-index:3;' +
      'background:rgba(255,255,255,.92);box-shadow:0 2px 16px rgba(0,0,0,.3)}' +
      '.sjp-film-btn::after{content:"";position:absolute;left:55%;top:50%;' +
      'transform:translate(-50%,-50%);border-style:solid;border-width:12px 0 12px 19px;' +
      'border-color:transparent transparent transparent #1a1410}';
    document.head.appendChild(s);
  })();

  function containers() {
    var slides = document.querySelectorAll('.sjp__media .product__media-item');
    var out = [];
    for (var i = 0; i < slides.length; i++) {
      var dm = slides[i].querySelector('deferred-media');
      var box = slides[i].querySelector('.product-media-container') || slides[i];
      if (dm && box.getBoundingClientRect().width > 40) out.push({ slide: slides[i], dm: dm, box: box });
    }
    return out;
  }

  /* How much of the slide is on screen, as a fraction of itself. Both axes: a
     gallery is a horizontal slider inside a scrolling page. */
  function seen(el) {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return 0;
    var w = Math.max(0, Math.min(r.right, window.innerWidth) - Math.max(r.left, 0));
    var h = Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
    return (w * h) / (r.width * r.height);
  }

  /* Dawn parks the real <video> in a <template>; take it and use it. */
  function build(item) {
    if (item.box.querySelector('.sjp-film-video')) return item.box.querySelector('.sjp-film-video');
    var tpl = item.dm.querySelector('template');
    if (!tpl) return null;
    var found = tpl.content ? tpl.content.querySelector('video') : null;
    if (!found) return null;

    var v = found.cloneNode(true);
    v.className = 'sjp-film-video';
    v.muted = true;
    v.defaultMuted = true;
    v.loop = true;
    v.controls = false;
    v.removeAttribute('controls');
    /* ⚠ DROP DAWN'S autoplay ATTRIBUTE. Left on, the browser starts the clone
       itself — which looks like success and is not: it plays off-screen, it
       plays under reduced motion, and it hides whether play() would have been
       refused, which is the one thing the button depends on knowing. */
    v.removeAttribute('autoplay');
    v.autoplay = false;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('preload', 'none');
    v.playsInline = true;

    if (getComputedStyle(item.box).position === 'static') item.box.style.position = 'relative';
    item.box.appendChild(v);

    /* The button is removed only when a frame has actually been shown. */
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sjp-film-btn';
    b.setAttribute('aria-label', 'Play film');
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      item.slide.dataset.sjpAsked = '1';
      v.muted = true;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    });
    item.box.appendChild(b);

    v.addEventListener('playing', function () { b.style.display = 'none'; });
    v.addEventListener('pause', function () { b.style.display = ''; });
    v.addEventListener('ended', function () { b.style.display = ''; });
    v.addEventListener('error', function () { b.style.display = ''; });
    return v;
  }

  function tick() {
    var list = containers();
    for (var i = 0; i < list.length; i++) {
      var v = build(list[i]);
      if (!v) continue;
      var fraction = seen(list[i].slide);
      var asked = list[i].slide.dataset.sjpAsked === '1';
      var here = asked ? fraction > 0.02 : fraction >= 0.35;

      if (here && !reduce) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});   /* the button is still there */
      } else if (!here && !v.paused) {
        v.pause();
      }
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; tick(); });
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('click', schedule, true);
  document.addEventListener('touchend', schedule, { passive: true });
  /* The slider scrolls its own box, which does not bubble a window scroll. */
  document.addEventListener('scroll', schedule, { capture: true, passive: true });

  window.setTimeout(schedule, 800);
  window.setTimeout(schedule, 2500);
  schedule();
})();
